const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    width: "100%",
  },
  tableBox: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  tableHeadCells: {
    // padding: "8px",
    color: "#000000",
    fontWeight: 600,
    background: "#BAD9EC",
  },
  actionBtn: {
    borderRadius: 0,
    fontSize: 12,
    color: "#FB5C5F",
    backgroundColor: "rgb(242, 242, 242)",
    padding: "2px 8px",
  },
  actionButtons: {
    display: "flex",
    gap: 22,
  },
  actionIcon: {
    cursor: "pointer",
  },
  typoghrphyStyle: {
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: "0.875rem",
  },
  reload: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#E6E6E6",
    borderRadius: 5,
    cursor: "pointer",
    padding: "6px",
  },
  recipientsContainer: {
    display: "flex",
    justifyContent: "space-between",
    gap: "20px",
    width: "100%",
    background: "rgb(186, 217, 236)",
    padding: "1rem",
    borderRadius: "4px",
  },
  recipientsContainerText: {
    margin: "5px 0 0 0",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "rgb(0, 0, 0)",
    fontWeight: "600",
  },
  ellipsisText: {
    margin: "5px 0 0 0",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "rgb(0, 0, 0)",
    fontWeight: "600",
  },
};

export default styles;
